import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { inject } from '@angular/core';

export const adminGuard: CanActivateFn = (route, state) => {

  const authService = inject(AuthService);
  const router = inject(Router);
  const token = localStorage.getItem('jwt');
  const isLoggedIn = token !== null && token.length > 0 && authService.isTokenValid(token);

  if (!isLoggedIn) {
      const loginPath = router.parseUrl("/login");
      return new RedirectCommand(loginPath, {
        skipLocationChange: true,
      });
    }

  return isLoggedIn;
};
